import { useEffect, useState } from "react";
import { CustomDialog } from "../../../../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';
import { DestinationRackLocationsFragment } from "./destination-rack-locations-fragment";
import { MovingItemsFragment } from "./moving-items-fragment";

const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;
`;

export function WegetMoveItemsModal({
    open,
    onClose,
    originRackLocation,
    onReqFetchRackLocations
}) {
    const [currentTab, setCurrentTab] = useState('DEFAULT'); // DEFAULT, MOVE
    const [destinationRackLocation, setDestinationRackLocation] = useState(null);

    const handleSelectDestinationRackLocation = (rackLocation) => {
        setDestinationRackLocation(rackLocation);
        setCurrentTab('MOVE');
    };

    const handleChangeTab = (tab) => {
        if (tab === 'DEFAULT') {
            setDestinationRackLocation(null);
        }
        setCurrentTab(tab);
    }

    return (
        <>
            <CustomDialog
                open={open}
                onClose={() => onClose()}
                maxWidth="lg"
            >
                {currentTab === 'DEFAULT' &&
                    <>
                        <StyledHeader>
                            <CustomDialog.Header>
                                <CustomDialog.Header.Fake />
                                <CustomDialog.Header.Title>이동할 로케이션 선택</CustomDialog.Header.Title>
                                <CustomDialog.Header.Close onClick={() => onClose()}></CustomDialog.Header.Close>
                            </CustomDialog.Header>
                        </StyledHeader>
                        <StyledBody>
                            <DestinationRackLocationsFragment
                                originRackLocation={originRackLocation}
                                onSelectDestinationRackLocation={handleSelectDestinationRackLocation}
                            />
                        </StyledBody>
                    </>
                }
                {currentTab === 'MOVE' &&
                    <>
                        <StyledHeader>
                            <CustomDialog.Header>
                                <CustomDialog.Header.Back onClick={() => handleChangeTab('DEFAULT')} />
                                <CustomDialog.Header.Title>이동하기</CustomDialog.Header.Title>
                                <CustomDialog.Header.Close onClick={() => onClose()}></CustomDialog.Header.Close>
                            </CustomDialog.Header>
                        </StyledHeader>
                        <StyledBody>
                            <MovingItemsFragment
                                originRackLocation={originRackLocation}
                                destinationRackLocation={destinationRackLocation}
                                onReqFetchRackLocation={onReqFetchRackLocations}
                                onClose={onClose}
                            />
                        </StyledBody>
                    </>
                }
            </CustomDialog>
        </>
    );
}